import { render, staticRenderFns } from "./DiscountPopinFormShared.vue?vue&type=template&id=c8b09364"
import script from "./DiscountPopinFormShared.vue?vue&type=script&lang=ts"
export * from "./DiscountPopinFormShared.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports